import { render } from "./DataEdit.vue?vue&type=template&id=7d71c8ff"
import script from "./DataEdit.vue?vue&type=script&lang=js"
export * from "./DataEdit.vue?vue&type=script&lang=js"

import "./DataEdit.vue?vue&type=style&index=0&id=7d71c8ff&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__